import { Injectable } from '@angular/core';
import { EntityService } from './entity.service';
import { JQueryHTTPClient } from './JQueryHTTPClient';
import { Rest } from './rest_client';

@Injectable()
export class VehicleversionService extends EntityService<Rest.VehicleVersion>{
  client: Rest.RestApplicationClient;
  constructor(private jquery: JQueryHTTPClient) {
    super();
    this.client = new Rest.RestApplicationClient(jquery);
  }

  getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest.VehicleVersion>> {
    return this.client.VehicleVersion_getPage(arg0);
  }


  create(arg0: Rest.VehicleVersion): Rest.RestResponse<any> {
    return this.client.VehicleVersion_create(arg0);
  }

  update(arg0: Rest.VehicleVersion): Rest.RestResponse<Rest.VehicleVersion> {
    return this.client.VehicleVersion_update(arg0);
  }

  changeStatus(
    arg0: number[],
    queryParams?: { status?: boolean}
  ): Rest.RestResponse<void> {
    return this.client.VehicleVersion_changeStatus(arg0, queryParams);
  }

  // @ts-ignore
  find(
    arg0: string,
    queryParams?: { id?: number }
  ): Rest.RestResponse<Rest.VehicleVersion> {
    return this.client.VehicleVersion_find(arg0, queryParams);
  }
}
